<template>
  <div
    :class="[visible ? '' : 'collapsed', 'row', 'curspointer']"
    :aria-expanded="visible ? 'true' : 'false'"
    aria-controls="collapse-5"
    @click="visible = !visible"
  >
    <!-- <div class="col-12 padd-0"> mode == 'phone' ? 'col-3 rightAlign' : -->

    <div class="col-1 centerAlign leftRightPaddingZero">
      <img class="phonePicture curspointer imgHover" :src="pic[mode]" />
    </div>
    <div class="col-10 pl0 pr10 wordBreak" v-if="arr != undefined && arr.length > 0">
      <div class="padTopBot">{{val || arr[0]}}</div>
      <b-collapse id="collapse-5" v-model="visible" class="mt-2 marginTop0">
        <div v-for="el in arr" :key="el">
          <div class="padTopBot">{{el}}</div>
        </div>
      </b-collapse>
    </div>
    <div :class="[mode == 'phone' ? 'col-9' : 'col-11', 'pl0', 'pr10', 'wordBreak']" v-else>
      <div class="padTopBot">No {{mode == 'phone' ? 'phones' : 'emails'}} on file</div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
export default {
  name: "MailPhoneBox",
  components: {},
  props: {
    val: String,
    arr: Array,
    mode: String
  },
  data() {
    return {
      visible: false,
      pic: {
        phone:
          "https://firebasestorage.googleapis.com/v0/b/car-appointment-fsqahl.appspot.com/o/roomadmin_pictures%2Fphone-512.webp?alt=media&token=f540a6f7-b567-45c5-a6c9-debfa0721cc5",
        email:
          "https://firebasestorage.googleapis.com/v0/b/car-appointment-fsqahl.appspot.com/o/roomadmin_pictures%2Ficon-email-512.webp?alt=media&token=80ca0d3f-4caa-42bd-b025-3851ecef5482"
      }
    };
  },
  created() {},

  mounted() {},

  watch: {},

  methods: {}
};
</script>
<style>
.padd-0 {
  padding: 0;
}
.leftRightPaddingZero {
  padding-left: 0px;
  padding-right: 0px;
}
.rightAlign {
  text-align: right;
}
.marginTop0 {
  margin: 0px !important;
}
.pl0 {
  padding-left: 0px;
  /* font-weight: bold; */
}
.pr0 {
  padding-right: 0px;
}
.pr10 {
  padding-right: 5px;
}
.phonePicture {
  width: 30px;
}
.curspointer {
  cursor: pointer;
}
.imgHover {
  padding: 5px;
}
.centerAlign {
  text-align: center;
}
.row {
  margin-left: 0;
  margin-right: 0;
}
@media (max-width: 1240px) {
  .leftRightPaddingZero {
    margin-right: 10px;
  }
}
</style>